import { avatarTokens } from './avatar';
import { badgeTokens } from './badge';
import { buttonTokens } from './button';
import { cardTokens } from './card';
import { checkboxTokens } from './checkbox';
import { chipTokens } from './chip';
import { carouselTokens } from './carousel';
import { datatableTokens } from './datatable';
import { dialogTokens } from './dialog';
import { inputtextTokens } from './inputtext';
import { multiselectTokens } from './multiselect';
import { paginatorTokens } from './paginator';
import { radiobuttonTokens } from './radiobutton';
import { selectTokens } from './select';
import { tabsTokens } from './tabs';
import { tagTokens } from './tag';
import { toastTokens } from './toast';
import { togglebuttonTokens } from './togglebutton';
import { toggleswitchTokens } from './toggleswitch';
import { toolbarTokens } from './toolbar';
import { skeletonTokens } from './skleton';
import { iconFieldTokens } from './iconfield';
import { accordionTokens } from './accordion';
import { datepickerTokens } from './datepicker';
import { menuTokens } from './menu';

export const ComponentTokens = {
    avatar: avatarTokens,
    badge: badgeTokens,
    button: buttonTokens,
    card: cardTokens,
    checkbox: checkboxTokens,
    chip: chipTokens,
    carousel: carouselTokens,
    datatable: datatableTokens,
    dialog: dialogTokens,
    inputtext: inputtextTokens,
    multiselect: multiselectTokens,
    paginator: paginatorTokens,
    radiobutton: radiobuttonTokens,
    select: selectTokens,
    tabs: tabsTokens,
    tag: tagTokens,
    toast: toastTokens,
    togglebutton: togglebuttonTokens,
    toggleswitch: toggleswitchTokens,
    toolbar: toolbarTokens,
    skeleton: skeletonTokens,
    iconfield: iconFieldTokens,
    accordion: accordionTokens,
    datepicker: datepickerTokens,
    menu: menuTokens
};